<template>
    <div class="alm-right-sidebar">
        <div class="alm-right-sidebar-header">
            <h3 :title="selectedAlmChangesets[0].name">{{selectedAlmChangesets[0].name}}</h3>
            <img class="theme-svg"
             role="button"
             tabindex="0"
             src="../../../../public/icons/landscape/close.svg"
             @click="close">
        </div>
        <f-tabs v-if="!selectedAlmTargetTenant" class="alm-right-sidebar-tabs">
            <f-tab-pane :tab="localizer.Localize('LandscapeManagement_Details')" :key="1">
                <div class="alm-right-sidebar-details">
                    <div class="alm-right-sidebar-details-item">
                        <h4 class="fs13">{{localizer.Localize('LandscapeManagement_Changeset_Description')}}</h4>
                        <span>{{selectedAlmChangesets[0].description ? selectedAlmChangesets[0].description : "N/a"}}</span>
                    </div>
                    <div class="alm-right-sidebar-details-item">
                        <h4 class="fs13">{{localizer.Localize('LandscapeManagement_Changeset_CreatedAt')}}</h4>
                        <span>{{selectedAlmChangesets[0].createdAt ? getFormattedDate(selectedAlmChangesets[0].createdAt) : ""}}</span>
                    </div>
                    <div class="alm-right-sidebar-details-item">
                        <h4 class="fs13">{{localizer.Localize('LandscapeManagement_Changeset_CreatedBy')}}</h4>
                        <span>{{selectedAlmChangesets[0].createdBy}}</span>
                    </div>
                    <div class="alm-right-sidebar-details-item">
                        <h4 class="fs13">{{localizer.Localize('LandscapeManagement_Changset_LastUpdated')}}</h4>
                        <span>{{selectedAlmChangesets[0].updatedAt ? getFormattedDate(selectedAlmChangesets[0].updatedAt) : ""}}</span>
                    </div>
                    <div class="alm-right-sidebar-details-item">
                        <h4 class="fs13">{{localizer.Localize('LandscapeManagement_Changeset_Source')}}</h4>
                        <span>{{selectedAlmChangesets[0].source}}</span>
                    </div>
                    <div class="alm-right-sidebar-details-item">
                        <h4 class="fs13">{{localizer.Localize('LandscapeManagement_Changeset_Target')}}</h4>
                        <span>{{getTargetTenant()}}</span>
                    </div>
                    <div class="alm-right-sidebar-details-item">
                        <h4 class="fs13">{{localizer.Localize('LandscapeManagement_Changeset_LastDeployed')}}</h4>
                        <span>{{selectedAlmChangesets[0].lastDeployed ? getFormattedDate(selectedAlmChangesets[0].lastDeployed) : localizer.Localize('LandscapeManagement_Never_Deployed_Text')}}</span>
                    </div>
                    <div class="alm-right-sidebar-details-item">
                        <h4 class="fs13">{{localizer.Localize('LandscapeManagement_Changeset_DeployedBy')}}</h4>
                        <span>{{selectedAlmChangesets[0].deployedBy ? selectedAlmChangesets[0].deployedBy : localizer.Localize('LandscapeManagement_Never_Deployed_Text')}}</span>
                    </div>
                </div>
            </f-tab-pane>
            <f-tab-pane :key="2">
                <template #tab>
                    <span>{{localizer.Localize('LandscapeManagement_Objects')}}</span>
                    <span v-if="selectedAlmChangesetItems" class='calm-badge'>{{selectedAlmChangesetItems?.length}}</span>
                </template>
                <div v-if="loadingChangesetItems" class="alm-right-sidebar-loading">
                    <f-spin :spinning="loadingChangesetItems" />
                </div>
                <div v-else-if="selectedAlmChangesets[0]?.count > 0 && selectedAlmChangesetItems"><AlmFileSelectionSection :selectedFiles="selectedAlmChangesetItems" :isReadonly="true" :isFilesExpanded="false"/></div>
                <div v-else class="alm-right-sidebar-empty-state">
                     <img src="../../../../public/icons/landscape/EmptyStateObjectsTab.svg" alt="Empty state icon" />
                        <h4 class="alm-right-sidebar-empty-state-text">{{localizer.Localize('LandscapeManagement_Objects_Empty_State_Text')}}</h4>
                        <span class="fs13">{{localizer.Localize('LandscapeManagement_Objects_Empty_State_Subtext')}}</span>
                </div>
            </f-tab-pane>
            <f-tab-pane :key="3">
                <template #tab>
                    <span>{{localizer.Localize('LandscapeManagement_Last_run')}}</span> <span class='calm-badge'>{{calculateLastRunTenants}}</span>
                </template>
                <div v-if="calculateLastRunTenants === 0" class="alm-right-sidebar-last-run">
                    <div class="alm-right-sidebar-empty-state">
                        <img src="../../../../public/icons/landscape/EmptyStateLastRun.svg" alt="Last Run Icon" />
                        <h4 class="alm-right-sidebar-empty-state-text">{{localizer.Localize('LandscapeManagement_Last_run_Empty_State_Text')}}</h4>
                    </div>
                </div>
                <AlmTimelineWrapper v-else :currentChangeset="selectedAlmChangesets[0]"/>
            </f-tab-pane>
        </f-tabs>
        <f-tabs v-else class="alm-right-sidebar-tabs">
            <f-tab-pane :key="1">
                <template #tab>
                    <span>{{localizer.Localize('LandscapeManagement_Last_run')}}</span>
                </template>
                <div v-if="!selectedAlmTargetTenant?.deployedAt" class="alm-right-sidebar-last-run">
                    <div class="alm-right-sidebar-empty-state">
                        <img src="../../../../public/icons/landscape/EmptyStateLastRun.svg" alt="Last Run Icon" />
                        <h4 class="alm-right-sidebar-empty-state-text">{{localizer.Localize('LandscapeManagement_Last_run_Empty_State_Text')}}</h4>
                    </div>
                </div>
                <AlmTimelineComponent :currentTenant="selectedAlmTargetTenant" />
            </f-tab-pane>
        </f-tabs>
        <div class="alm-right-button-container">
            <f-button type="text" :disabled="selectedAlmChangesets?.[0]?.status === STATUS.DEPLOYING" @click="handleEdit">{{localizer.Localize('Edit')}}</f-button>
            <f-button type="primary" :disabled="deployButtonDisabled" @click="handleDeployment">{{localizer.Localize('LandscapeManagement_Deploy_Text')}}</f-button>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import {Localizer} from '@/api/Localizer';
import * as api from '@/api/ApiClient';
import AlmFileSelectionSection from "@/components/pages/landscape/AlmFileSelectionSection.vue";
import { FormatDateTime, getDeepErrorMessage } from '@/utils/Utils';
import { isButtonDisabled } from '@/components/pages/landscape/AlmUtils';
import AlmTimelineWrapper from '@/components/pages/landscape/AlmTimelineWrapper.vue';
import AlmTimelineComponent from '@/components/pages/landscape/AlmTimelineComponent.vue';
import { STATUS } from './LandscapeManagementInterfaces';

export default defineComponent({
    components: {
        AlmFileSelectionSection,
        AlmTimelineWrapper,
        AlmTimelineComponent
    },
    data() {
        return {
            localizer: new Localizer(this.$store),
            loadingChangesetItems: true,
            STATUS
        }
    },
    computed: {
        ...mapGetters('alm', [
            'selectedAlmChangesets',
            'changesetItems',
            'selectedAlmTargetTenant'
        ]),
        selectedAlmChangesetItems() {
            return this.changesetItems;
        },
        deployButtonDisabled() {
            const status = this.selectedAlmChangesets?.[0]?.status || '';
            return isButtonDisabled(status);
        },
        calculateLastRunTenants() {
            const changeset = this.selectedAlmChangesets[0];
            if (changeset?.detail && Array.isArray(changeset.detail) && changeset.detail?.length > 0) {
                const deployedTenants = changeset.detail.filter((tenant: any) => tenant?.deployedAt);
                return deployedTenants?.length || 0;
            }
            return 0;
        }
    },
    async mounted() {
        try {
            this.setChangesetItems(null);
            await this.getChangesetItems();
        }
        catch (e) {
            const errorMessage = getDeepErrorMessage(e);
            await this.ShowToast(new api.ToastNotification({
                message: errorMessage || this.localizer.Localize('Failed_status'),
                type: api.ToastType.Error
            }));
        }
        finally {
            this.loadingChangesetItems = false;
        }
    },
    methods: {
        ...mapMutations('alm', [
            'setSelectedAlmChangesets',
            'setChangesetItems'
        ]),
        ...mapActions(['ShowToast']),
        ...mapActions('alm', [
            'getChangesetItems',
        ]),
        getFormattedDate(date: Date | string): string {
            return FormatDateTime(date);
        },
        getTargetTenant() {
            const changeset = this.selectedAlmChangesets[0];
            if (changeset?.detail && Array.isArray(changeset.detail) && changeset.detail.length > 0) {

                const tenantNames = changeset.detail
                    .map((detail: any) => {
                        if (detail.tenant) {
                            return detail.tenant;
                        }
                        return null;
                    })
                    .filter((name: string | null) => name) 
                    .join(', '); 

                return tenantNames || "";
            }
            
            return "";
        },
        handleEdit() {
            this.$emit('edit');
        },
        handleDeployment() {
            if (!this.deployButtonDisabled) {
                this.$emit('deploy', this.selectedAlmChangesets[0]);
            }
        },
        close() {
            this.$emit('close');
        }
    }
})
</script>

<style scoped>
.alm-right-sidebar {
    height: 100%;
    width: 320px;
    border-left: solid 1px var(--accent-color-blue-12);
    display: flex;
    flex-direction: column;
    padding: 16px 0;
    gap: 16px;
    overflow: auto;
}

.alm-right-sidebar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
}

.alm-right-sidebar-header > h3 {
    margin: 0;
    font-weight: 600;
    font-size: 18px;
    max-width: 230px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: capitalize;
}

.alm-right-sidebar-header > img {
    cursor: pointer;
}

.alm-right-sidebar-tabs {
    flex: 1;
}

:deep(.ant-tabs>.ant-tabs-nav) {
   margin: 0 16px;
}

:deep(.ant-tabs-content-holder){
    margin: 16px 0;
    padding: 0 16px;
    overflow-y: auto;
}

:deep(.ant-tabs-nav-list) {
    width: 100%;
    justify-content: space-between;
}

:deep(.alm-right-sidebar-tabs .ant-tabs-nav-operations) {
    display: none;
}

:deep(.ant-tabs-tab-btn) {
    font-weight: 600;
    font-size: 13px;
    display: flex;
    align-items: center;
}

.calm-badge {
    display: inline-flex;
    height: 14px;
    border-radius: 4px;
    padding: 4px;
    background-color: var(--background-primary);
    border: solid 1px var(--accent-color5);
    font-weight: 600;
    font-size: 9px;
    line-height: 6px;
    color: var(--accent-color5);
    margin-left: 4px;
}

.alm-right-sidebar-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.alm-right-sidebar-details {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.alm-right-sidebar-details-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.alm-right-sidebar-details-item > h4 {
    margin: 0;
}

.fs13 {
    font-size: 13px;
}

.alm-right-sidebar-last-run{
    padding: 16px;
    height: calc(100% - 32px);
}

.alm-right-sidebar-empty-state {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    height: 100%;
}

.alm-right-sidebar-empty-state-text {
    font-size: 14px;
    margin: 0;
}

.alm-right-button-container {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-right: 16px;
}
</style>
